import { Typography, Box } from '@mui/material';
import { useState, useEffect } from 'react';

import { Employer } from '@libs/models';
import { FormProvider } from '@carcareers/contexts';
import { useEmployerProfileQuery } from '@carcareers/store';
import { useAuth } from '@carcareers/hooks';
import {
  Payment,
  EmployerUpdateForm,
  DeleteAccountAction,
  AddPaymentModal,
  DashboardPageContainer,
  UserPreferences,
} from '@carcareers/components';

export const EmployerSettings = () => {
  const [employer, setEmployer] = useState<Employer>();
  const [isAddPaymentModalOpen, setIsAddPaymentModalOpen] = useState(false);

  const auth = useAuth();
  const { data: employerData, isLoading } = useEmployerProfileQuery(auth.session?.user?.id ?? 0, {
    skip: !auth.session?.user?.id,
  });

  useEffect(() => {
    if (employerData) {
      setEmployer(employerData);
    }
  }, [employerData]);

  return (
    <DashboardPageContainer loading={isLoading}>
      <FormProvider initialData={employer}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            backgroundColor: 'background.paper',
            borderRadius: 3,
            p: 2,
          }}
        >
          <EmployerUpdateForm />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flexWrap: 'wrap',
            gap: 2,
            py: 2,
            backgroundColor: 'background.paper',
            borderRadius: 3,
            p: 2,
            mt: 3,
          }}
        >
          <Typography variant="h4">Payment Methods</Typography>
          <Payment onClickIsNew={() => setIsAddPaymentModalOpen(true)} />
        </Box>
      </FormProvider>
      <Box sx={{ mt: 3 }}>
        <UserPreferences />
      </Box>
      <Box
        sx={{
          px: 4,
          py: 2,
          mb: 2,
          display: 'flex',
          gap: 2,
          flexDirection: 'column',
          border: '1px solid',
          borderColor: 'error.light',
          borderRadius: 3,
          mt: 3,
          backgroundColor: 'background.paper',
        }}
      >
        <Typography variant="h5" sx={{ color: 'error.light' }}>
          Danger Zone
        </Typography>
        <DeleteAccountAction />
      </Box>

      <AddPaymentModal open={isAddPaymentModalOpen} onClose={() => setIsAddPaymentModalOpen(false)} />
    </DashboardPageContainer>
  );
};

export default EmployerSettings;
